import React, { useMemo } from 'react';
import styles from './M_WheelColumn.module.css';
import cn from 'classnames';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';
export interface WheelColumnProps {
  value: number;
  min: number;
  max: number;
  pad?: number;
  visibleSlots?: 3 | 5;
}

export default function M_WheelColumn({
  value,
  min,
  max,
  pad = 2,
  visibleSlots = 5,
}: WheelColumnProps) {
  const slotHeight = 90;
  const slotsHalf = visibleSlots === 3 ? 1 : 2;
  const centerTop = slotHeight * slotsHalf;

  const offsets = useMemo(
    () =>
      visibleSlots === 3 ? ([-1, 0, 1] as const) : ([-2, -1, 0, 1, 2] as const),
    [visibleSlots]
  );
  const visibleItems = useMemo(
    () =>
      offsets.map(offset => {
        const v = value + offset;
        const inRange = v >= min && v <= max;
        return {
          key: inRange ? String(v) : `p-${offset}`,
          display: inRange ? String(v).padStart(pad, '0') : '',
          offset,
        };
      }),
    [offsets, value, min, max, pad]
  );

  const listHeight = visibleSlots === 3 ? 270 : 450;

  return (
    <div className={styles.wrapper}>
      <div className={styles.list} style={{ height: listHeight }}>
        <Q_BlurEffect yAxis='top' zIndex={100} />
        {visibleItems.map(({ key, display, offset }) => (
          <div
            key={key}
            className={cn(styles.item, {
              [styles.active]: offset === 0,
              [styles.prev1]: offset === -1,
              [styles.prev2]: visibleSlots === 5 && offset === -2,
              [styles.next1]: offset === 1,
              [styles.next2]: visibleSlots === 5 && offset === 2,
            })}
            style={{ top: centerTop + offset * slotHeight }}
            aria-hidden={offset !== 0}
          >
            <span className={styles.item_text}>{display}</span>
          </div>
        ))}
        <Q_BlurEffect yAxis='bottom' zIndex={100} />
      </div>
    </div>
  );
}
